<script lang="ts" generics="ITEM">
    import type {SearchParams, ViewableSearch} from 'src/typings';
    import type {SearchManager} from '../search-manager/search-manager';
    import type {Observable} from 'rxjs';
    import {exists} from 'shared/utils/custom-utils';
    import KpAuthorityIndexSearchForm from './KpAuthorityIndexSearchForm.svelte';

    export let searchManager: SearchManager<ITEM>;

    let lastSearch: Observable<ViewableSearch<SearchParams, ITEM>>;
    $: lastSearch = searchManager.getLastSearch$();
</script>

{#if exists($lastSearch) && $lastSearch.type === 'authority-index'}
    <KpAuthorityIndexSearchForm/>
{/if}